<div class="sgt-canal-venda-logo-badge" title="{{nome}}">
    <img *ngIf="useAsMini" [src]="logoMiniURL" [attr.alt]="nome" [attr.title]="nome" [ngStyle]="styles">
    <img *ngIf="!useAsMini" [src]="logoURL" [attr.alt]="nome" [attr.title]="nome" [ngStyle]="styles">
    <span *ngIf="isShowNome">{{nome}}</span>
</div>  